import { Navigate, Outlet } from "react-router";
import { useSelector } from "react-redux";
import { getUserStoreData } from "store/slices";

const ContactUsRoute = () => {
  const { districts, is_onboarding_complete } = useSelector(getUserStoreData);

  if (!is_onboarding_complete) {
    return <Navigate to="/onboarding" replace />;
  }

  if (districts.length) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

export default ContactUsRoute;
